import React, { useEffect, useState } from 'react';
import { UserStake } from '../../model/round.model';
import { useConnectedUser } from '../../context/connected-user.context';

export const MyStakesForRound: React.FC<{stakingRoundId: string}> = ({stakingRoundId}) => {
    const connectedUser = useConnectedUser();
    const [userStakes, setUserStakes] = useState<UserStake[]>([]);

    const getUserStakes = async () => {
        if (connectedUser.contract) {
            const userStakes = await connectedUser.contract.stakingFacet.getUserStakes(stakingRoundId, connectedUser.connectedUser!.walletAddress);
            setUserStakes(userStakes);
        }
    };

    useEffect(() => {
        getUserStakes();
    }, [stakingRoundId]);

    return (
        <>
            {userStakes.length === 0 && <div>No stakes found</div>}
            {userStakes.length > 0 && (
                <ul>
                    {userStakes.map((stake) => (
                        <li key={stake.createdAt}>{stake.amount} CDK</li>
                    ))}
                </ul>
            )}
        </>
    )
}
